import React, { useState, useEffect, useCallback } from "react";
import {
    Drawer,
    Button,
    Form,
    Input,
    Select,

} from "antd";
import {
    QuestionCircleOutlined
} from "@ant-design/icons";
import common_api from "../../config/common_api";
import { triggerNotification } from "../common/notify";


const CreateDrawer = ({ visible, onClose, setisloader, onProductCreate, attributesList = [] }) => {
    const [form] = Form.useForm();
    const [attributeType, setAttributeType] = useState("");

    useEffect(() => {
        if (attributeType === "dropdown") {
            form.setFieldsValue({ max_value: 1 });
        }
    }, [attributeType, form]);
    const handleSaveAndPublish = async (val) => {
        let values;
        try {
            values = await form.validateFields();
        } catch (err) {
            triggerNotification({ type: "error", message: "Please fix all errors before saving." });
            return;
        }
        const { attribute_name, attribute_key, AttributeType, max_value } = values;

        // Duplicate check
        const isDuplicate = attributesList.some(
            attr =>
                (attr.attribute_label?.toLowerCase() === attribute_name.trim().toLowerCase()) ||
                (attr.attribute_key?.toLowerCase() === attribute_key.trim().toLowerCase())
        );
        if (isDuplicate) {
            triggerNotification({ type: "error", message: "Duplicate Attribute Name or Key found." });
            return;
        }

        let finalPattern = ''
        if (attribute_key.includes("NUM")) {
            let splitArry = attribute_key.split("NUM")
            const pre = splitArry[0], post = splitArry[1]
            finalPattern = `^${pre}\d{([1-9]|[1-9][0-9])|${parseInt(max_value)}}${post}$`

        } else if (max_value === 1) {
            finalPattern = attribute_key
        }
        else {
            finalPattern = `^${attribute_key}_([1-9]|[1-9][0-9])|${max_value}$`
        }
        // return 1
        let req_data = {
            attribute_label: attribute_name,
            attribute_key: attribute_key,
            attri_pattern: finalPattern,
            attribute_element_type: AttributeType,
            max_size: parseInt(max_value),
            min_size: 1,
            info_text: "This is the PDP Gallery.",
            status: true,
            is_required: true,
            store_id: 5
        }
        setisloader(true);
        let responsedata = await common_api.add_attributes(req_data);
        if (responsedata) {
            let atName = attributeType === "dropdown" ? attribute_name : ""
            await onProductCreate(atName);
            triggerNotification(responsedata);
        }
        setisloader(false);
        onClose()
    }
    return (
        <>
            <Drawer className={`DrawerBox`}
                title={"New Attribute"}
                width={600}
                onClose={onClose}
                open={visible}

                extra={
                    <>
                        <div className="DrawerButtonBox">
                            {attributeType === "dropdown" ? (
                                <Button type="primary" onClick={handleSaveAndPublish}>
                                    Save & Continue
                                </Button>
                            ) : (
                                <Button type="primary" onClick={handleSaveAndPublish}>
                                    Save & Publish
                                </Button>
                            )}
                        </div>
                    </>
                }
            >
                <Form className="AttrForm" layout="vertical" form={form}>
                    <div className={`AttrFlexItemBox`}>
                        <Form.Item
                            label={
                                <span>
                                    Attribute Name&nbsp;
                                </span>
                            }
                            name="attribute_name"
                            rules={[
                                {
                                    required: true,
                                    validator: (_, value) => {
                                        if (!value) {
                                            return Promise.reject(new Error("Please Enter Attribute Name"));
                                        }
                                        if (value.trim() === "") {
                                            return Promise.reject(new Error("Attribute Name cannot be empty or just spaces"));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="Enter Attribute Name" />
                        </Form.Item>
                        <Form.Item
                            label={
                                <span>
                                    Attribute Key&nbsp;
                                </span>
                            }
                            name="attribute_key"
                            rules={[
                                {
                                    required: true,
                                    validator: (_, value) => {
                                        if (!value) {
                                            return Promise.reject(new Error("Please Enter Attribute Key"));
                                        }
                                        if (value.trim() === "") {
                                            return Promise.reject(new Error("Attribute Key cannot be empty or just spaces"));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="Enter Attribute Key" onChange={(e) => {
                                const formattedValue = e.target.value.toUpperCase().replace(/\s+/g, '_');
                                form.setFieldsValue({ attribute_key: formattedValue });
                            }} />
                        </Form.Item>
                        <Form.Item
                            label={<>Attribute Type&nbsp; <QuestionCircleOutlined
                                style={{
                                    color: "rgba(0, 0, 0, 0.45)",
                                    cursor: "pointer",
                                }}
                                title="This is the name shown on the Attribute Type."
                            /></>}
                            name="AttributeType"
                            rules={[{ required: true, message: "Please Select Attribute Type" }]}
                        >
                            <Select
                                placeholder="Select Attribute Type"
                                options={[
                                    { value: 'textfield', label: 'textfield' },
                                    { value: 'dropdown', label: 'dropdown' },
                                ]}
                                onChange={(value) => setAttributeType(value)}
                            />
                        </Form.Item>
                        <Form.Item
                            label={<>Max Value&nbsp;
                                <QuestionCircleOutlined
                                    style={{
                                        color: "rgba(0, 0, 0, 0.45)",
                                        cursor: "pointer",
                                    }}
                                    title="This is the Max Value."
                                />
                            </>}
                            name="max_value"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Max Value",
                                },
                                {
                                    validator: (_, value) => {
                                        if (value !== undefined && value !== null && value !== "") {
                                            if (Number(value) < 1) {
                                                return Promise.reject("Max Value must be at least 1");
                                            }
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ]}
                        >
                            <Input
                                type="number"
                                min={1}
                                placeholder="Enter Max Value"
                                disabled={attributeType === "dropdown"}
                                onKeyDown={(e) => {
                                    if (e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                    </div>
                </Form>
            </Drawer>
        </>
    );
}
export default CreateDrawer;